module.exports = __webpack_public_path__ + "static/img/metamask.80db1fb2.png";